import axios from '@/api'

export default {
  fetchDrivers({ commit }, payload){
    return new Promise((resolve, reject) => {
      if(payload.page){
        commit('SET_CURRENT_PAGE', payload.page)
      }
      axios.get('/admin/drivers/',{params: payload})
      .then((response) => {
        commit('UPDATE_DRIVERS', response.data)
        resolve(response.data)
      })
      .catch((error) => { reject(error.response) })
    })
  },
  getDrivers({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/drivers/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getDriversLogs({ commit }, payload){

    return new Promise((resolve, reject) => {
      console.log('/admin/drivers/'+payload.id+'/logs/'+payload.params)
      axios.get('/admin/drivers/'+payload.id+'/logs/',{params: payload.params})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getDriversLogsDetails({ commit }, payload){
    return new Promise((resolve, reject) => {
      console.log('/admin/drivers/'+payload.id+'/logs/'+payload.params)
      axios.get('/admin/drivers/'+payload.id+'/logs/'+payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  MassLoadDrivers({ commit }, formData){
    return new Promise((resolve, reject) => {
      axios.post('/admin/drivers/import/',formData,{headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  }, 
  CheckDriverProgress({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/drivers/import/'+payload.task_id+'/progress/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  fetchDrivesReport({ commit },payload){ 
    return new Promise((resolve, reject) => {
      axios.get(`/admin/drivers/`, {params:  payload , headers:{
        responseType: 'blob'
    }, responseType: 'blob' })
          .then((response) => {
            
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
    })
  },
  storeDriver({commit},payload){
    return new Promise((resolve, reject)=>{
      axios.post('/admin/drivers/',payload)
        .then(response=>{
          resolve(response.data);
        })
        .catch(error =>{
          reject(error.response)
        })
    })
  },
  getDriver({ commit },payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/drivers/'+payload.id+"/")
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateDriver({ commit },payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/drivers/'+payload.id+'/';
      delete payload.id;
      axios.put(url,payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteDriver({ commit },payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/drivers/'+payload.id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
}
